import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function SavingsDef({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/InterestDef");
    };

    const goPrev = () => {
        navigate("/HedgeFunds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Savings
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Savings are the amount of money left after subtracting your consumer 
                </div>
                <div className="text-[#000000] text-3xl">
                    spending from your income and are typically put into a bank where it can grow 
                </div>
                <div className="text-[#000000] text-3xl">
                    due to interest.
                </div>
                <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                    onClick={goNext}
                >
                    Next
                </button>
                <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                    onClick={goPrev}
                >
                    Prev
                </button>
            </div>
        </div>
    );
}